module.exports = __webpack_public_path__ + "static/img/device_mini_8.ae19c37.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/device_mini_8.png
// module id = znDR
// module chunks = 16